import { Sector } from './booking.model';
import { ProductTypeUrl } from './enums/ProductTypeUrl.enum';
import {
    Experiences, Packages, TravelPassesInitialData, ExpressInitialData, Accommodation, InitialDataService } from 'app/initial-data.service';

export class Availability {
    TravelGUID: string;
    RouteOptions: Array<RouteOption>;
    TravelAlternatives: Array<TravelAlternative>;
    FareGUID: string;
    NextTravelDate: string;
    SelectedDate: string;
    TravelDate: string;
    PreviousTravelDate: string;
    NextAvailabilityDate: string;
    PreviousAvailabilityDate: string;
    OriginStopCode: string;
    DestinationStopCode: string;
    Messages?: Array<string>;
}

export class TravelAlternative {
    ServiceDepartureDate: string;
    S1DepartTime: string;
    TotalDistance: number;
    TripDuration: number;
    BetterAlternative: boolean;
}

export class RouteOption {
    DepartureDate: string;
    ArrivalDate: string;
    RouteDistance: number;
    RouteTotalDuration: number;
    Connections: number;
    RouteHeader: string;
    RouteServices: Array<RouteService>;
    Fares: Array<any>;
    Sectors: Array<Sector>;
    timetableDisplayed: boolean;
    timetable: any;
    fullRoute: any;
    serviceList: any;
    RouteTravelDurationText: any;
    index: number;
    mapReady: boolean;
}

export class RouteService {
    Stops: Array<Stop>;
}

export class Stop {
    StopDetails: Array<StopDetails>;
    date: string;
    ArrivalDate: string;
    DepartureDate: string;
}

export class StopDetails {
    Code: string;
    StopDetails: StopDetails;
}
export class ProductUrl {
    public ProductTypeUrl: ProductTypeUrl;
    public get ProductName(): string {
        return ProductTypeUrl[this.ProductTypeUrl];
    }
    private Packages: Packages;
    private Experiences: Experiences;
    private Accommodation: Accommodation;
    private ExpressInitialData: ExpressInitialData;
    private TravelPassesInitialData: TravelPassesInitialData;
    public isManageBooking: boolean;
    constructor(url: string, private initialDataService: InitialDataService, productType?: ProductTypeUrl) {
        var urlSplit = url.split('/');
        var prodType = urlSplit[1];
        var categoryRef = urlSplit[2];
        var productRef = urlSplit[3];
        console.log('urlSplit', urlSplit);
        if (!!productType) {
            url = ''; // so we only check against the productType
        }

        if (url.indexOf('booking-management') > -1) {
            this.isManageBooking = true;
        } else {
            this.isManageBooking = false;
        }

        if (productType === ProductTypeUrl.package  || prodType === 'packages' || url.includes(this.initialDataService.packageParentFolderUrl)) {
            this.Packages = new Packages();
            this.Packages.DetailsUrl =  `/${prodType}/${categoryRef}/${productRef}`; //  this.initialDataService.packageDetails;
            this.Packages.PassengersUrl = this.initialDataService.packagePassengers;
            this.Packages.CategoriesUrl =  `/${prodType}/${categoryRef}/`; //this.initialDataService.packageCategories;
            this.Packages.ProductsUrl =  `/${prodType}/`; // this.initialDataService.packageProducts;
            this.Packages.ParentFolderUrl = this.initialDataService.packageParentFolderUrl;
        } else if (productType === ProductTypeUrl.experience  || prodType === 'experiences' || url.includes(this.initialDataService.experienceParentFolderUrl)) {
            this.Experiences = new Experiences();
            this.Experiences.DetailsUrl = this.initialDataService.experienceDetails;
            this.Experiences.PassengersUrl = this.initialDataService.experiencePassengers;
            this.Experiences.CategoriesUrl = this.initialDataService.experienceCategories;
            this.Experiences.ProductsUrl = this.initialDataService.experienceProducts;
            this.Experiences.ParentFolderUrl = this.initialDataService.experienceParentFolderUrl;
        } else if (productType === ProductTypeUrl.accommodation || prodType === 'accommodation' || url.includes(this.initialDataService.accommodationParentFolderUrl)) {
            this.Accommodation = new Accommodation();
            this.Accommodation.DetailsUrl = this.initialDataService.accommodationDetails;
            this.Accommodation.PassengersUrl = this.initialDataService.accommodationPassengers;
            this.Accommodation.CategoriesUrl = this.initialDataService.accommodationCategories;
            this.Accommodation.ProductsUrl = this.initialDataService.accommodationProducts;
            this.Accommodation.ParentFolderUrl = this.initialDataService.accommodationParentFolderUrl;
        } else if (productType === ProductTypeUrl.travelPasses  || prodType === 'travel-passes' || url.includes(this.initialDataService.travelPassesParentFolderUrl)) {
            this.TravelPassesInitialData = new TravelPassesInitialData();
            this.TravelPassesInitialData.DetailsUrl = this.initialDataService.travelPassesDetails;
            this.TravelPassesInitialData.PassengersUrl = this.initialDataService.travelPassesPassengers;
            this.TravelPassesInitialData.PaymentUrl = this.initialDataService.travelPassesPayment;
            this.TravelPassesInitialData.CategoriesUrl = this.initialDataService.travelPassesCategories;
            this.TravelPassesInitialData.ProductsUrl = this.initialDataService.travelPassesProducts;
            this.TravelPassesInitialData.ParentFolderUrl = this.initialDataService.travelPassesParentFolderUrl;
        } else if (productType === ProductTypeUrl.expressBooking || url.includes(this.initialDataService.expressParentFolderUrl)) {
            this.ExpressInitialData = new ExpressInitialData();
            // there is no DetailsUrl
            this.ExpressInitialData.PassengersUrl = this.initialDataService.expressPassengers;
            this.ExpressInitialData.PaymentUrl = this.initialDataService.expressPayment;
            this.ExpressInitialData.AvailabilityUrl = this.initialDataService.expressAvailability;
            this.ExpressInitialData.ParentFolderUrl = this.initialDataService.expressParentFolderUrl;
        }
        if (!!this.Packages) {
            this.ProductTypeUrl = ProductTypeUrl.package;
        } else if (!!this.Experiences) {
            this.ProductTypeUrl = ProductTypeUrl.experience;
        } else if (!!this.Accommodation) {
            this.ProductTypeUrl = ProductTypeUrl.accommodation;
        } else if (!!this.ExpressInitialData) {
            this.ProductTypeUrl = ProductTypeUrl.expressBooking;
        } else if (!!this.TravelPassesInitialData) {
            this.ProductTypeUrl = ProductTypeUrl.travelPasses;
        } else {
            this.ProductTypeUrl = ProductTypeUrl.manageBooking;
        }
    }
    private getProductInfo(): Packages | Experiences | Accommodation | ExpressInitialData | TravelPassesInitialData {
        return this.Packages || this.Experiences || this.Accommodation || this.ExpressInitialData || this.TravelPassesInitialData;
    }
    public get ProductDetailsUrl(): string {
        const p = this.getProductInfo();
        if (p instanceof ExpressInitialData) {
            throw new Error('Express booking does not have a details page');
        }
        return p.DetailsUrl;
    }
    public get ProductPassengersUrl(): string {
        const p = this.getProductInfo();
        if (p instanceof ExpressInitialData) {
            return p.PassengersUrl;
        }
        return p.PassengersUrl;
    }
    public get ProductPaymentUrl(): string {
        const p = this.getProductInfo();
        if (p instanceof ExpressInitialData) {
            return p.PaymentUrl;
        }
        return p.ParentFolderUrl;
    }
    public get ProductAvailability(): string {
        const p = this.getProductInfo();
        if (p instanceof ExpressInitialData && !(p instanceof TravelPassesInitialData)) {
            return p.AvailabilityUrl;
        }
        return p.ParentFolderUrl;
    }
    public get ProductParentFolderUrl(): string {
        const p = this.getProductInfo();
        return p.ParentFolderUrl;
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/models/availability.model.ts